<template>
  <div id="app" v-show="loaded" @logout="cancelNominativo()">
    <header>
      <b-navbar toggleable="md" type="dark" variant="dark">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-brand href="/" style="font-size:x-large">
          <img src="./assets/logo.png" width="30" height="30" alt="Giustup logo"> GiustUp.it
        </b-navbar-brand>
        <preferenze></preferenze>
        <b-collapse is-nav id="nav-collapse" v-if="nominativo">
          <b-navbar-nav>
            <b-nav-item href="/" active-class="active" class="mr-3">
              <font-awesome-icon icon="search" /> Home
            </b-nav-item>
            <b-nav-item :to="{ name: 'Newsletter' }" active-class="active" class="mr-3">
              <font-awesome-icon icon="envelope" /> Newsletter
            </b-nav-item>
            <b-nav-item :to="{ name: 'Privacy' }" active-class="active" class="mr-3">
              <font-awesome-icon icon="gavel" /> Info sulla privacy
            </b-nav-item>
            <b-nav-item :to="{ name: 'Utente' }" active-class="active" class="mr-3">
              <font-awesome-icon icon="user-circle" /> Abbonamento
            </b-nav-item>
            <b-nav-text v-if="giorniRimasti && giorniRimasti <= 25 && giorniRimasti >= 0" class="mr-3">
              Giorni rimanenti: <span class="text-warning">{{giorniRimasti}} giorni rimanenti</span>
            </b-nav-text>
            <b-nav-text v-if="giorniRimasti && giorniRimasti < 0" class="mr-3">
              <span class="testo-scaduto text-warning">Abbonamento scaduto!</span>
            </b-nav-text>

            <b-nav-item :to="{ name: 'Profilo', params: { codFisc: codFisc } }" v-if="nominativo" active-class="active" class="mr-3">
              <b-img rounded="circle" :src="getAvatarUrl(codFisc)" width="25" />&nbsp; {{nominativo}}
            </b-nav-item>

            <!-- ADMIN -->
            <b-nav-item-dropdown v-if="admin">
              <template v-slot:button-content>
                Admin
              </template>
              <b-dropdown-item :to="{ name: 'GestioneUtenti' }" active-class="active">Gestione utenti</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'SocialSentenze' }" active-class="active">Gestione social</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'AdminNewsletter' }" active-class="active">Iscritti newsletter</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item :to="{ name: 'Logout' }" active-class="active" class="mr-3">
              <font-awesome-icon icon="sign-out-alt" /> Esci
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <!--
    <div class="text-right pr-1 pt-1" style="width: 100%">
      <b-button v-if="nominativo" variant="outline-dark" :to="{ name: 'Profilo', params: { codFisc: codFisc } }">
        <b-img rounded="circle" :src="getAvatarUrl(codFisc)" width="25" />&nbsp; {{nominativo}}
      </b-button>
    </div>
    -->
    <main class="mt-1 mb-3">
      <keep-alive exclude="sentenza">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </main>
    <footer class="bg-dark text-white">
      <b-container fluid>
        <b-row class="text-center p-3">
          <b-col sm="12" md="4" class="py-2">
            Condizioni generali, privacy e cookies<br/>
            <a href="https://www.facebook.com/giustup.it/" target="_blank">
              <font-awesome-icon :icon="['fab', 'facebook']" /> Seguici su Facebook!
            </a>
          </b-col>
          <b-col sm="12" md="4" class="py-2">
            Editrice: <b>Presslex della Dott.ssa Chiara Morocchi</b><br/>
            Via Dante Alighieri 17 - Castelfranco<br/>
            c.a.p. 52026 Castelfranco Piandiscò (AR)<br/>
            C.F. MRCCHR73E67D583D - P.I. 02124850518<br/>
            Fax: +39 055.56.09.352<br/>
            Email: <a href="mailto:admin@giustup.it">admin@giustup.it</a> - PEC: giustup@pec.it<br/>
          </b-col>
          <b-col sm="12" md="4" class="py-2">
            Bonifico intestato a: PressLex della Dott.ssa Chiara Morocchi<br/>
            Banca del Valdarno<br/>
            Filiale di Castelfranco e Pian di Scò (AR)<br/>
            IBAN: IT71O0881105453000000303325<br/>
            BIC\SWIFT: ICRA IT RRMJ0
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>

<script>
import api from './services/service.js'
import oauth from './services/oauth.js'
import router from './router/index.js';
import Preferenze from './components/Preferenze.vue';

export default {
    name: "app",
    data() {
        return {
            nominativo: "",
            admin: false,
            giorniRimasti: null,
            codFisc: "",
            loaded: false
        };
    },
    // watch: {
    //   nominativo(newNominativo, oldNominativo) {
    //     if (newNominativo)
    //       this.$forceUpdate();
    //   }
    // },
    methods: {
        async getUsername() {
            let data = await api.execute("get", "utente/fullname");
            this.nominativo = data.nome;
            this.giorniRimasti = data.giorniRimasti;
        },
        async getAdmin() {
            let data = await api.execute("get", "utente/isadmin");
            this.admin = data;
        },
        getAvatarUrl(codFisc) {
            return api.getBaseUrl() + "utente/" + codFisc + "/immagine?nocache=" + Math.random();
        },
        async getProfiloLoggato() {
            let data = await api.execute("get", "profilo/me");
            this.codFisc = data.codFisc;
        },
        async checkLogged() {
            let data = await api.execute("get", "oauth");
            return data;
        },
        cancelNominativo() {
            this.nominativo = "";
            console.log(this.nominativo);
        }
    },
    async mounted() {
        // debugger
        // FUNZIONA PERÒ
        // this.$router.beforeEach(async (to, from) => {
        //   if (!(await this.checkLogged())) {
        //     console.log('non loggato')
        //   }
        //   console.log('loggato')
        // });
        if (await this.checkLogged()) {
            await this.getUsername();
            await this.getAdmin();
            await this.getProfiloLoggato();
        }
    },
    async updated() {
        if (await this.checkLogged()) {
            this.getUsername();
            this.getAdmin();
            this.getProfiloLoggato();
        }
    },
    components: { Preferenze }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
}

header {
  text-align: center;
  background-color: #343a40;
}

header .navbar {
  display: inline-flex;
}

header .nav-link {
  outline: none;
}

.testo-scaduto{
  animation: blinker 2s linear infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue